import { IGender } from '../../../../../../redux/slices/ModularEnrolmentSlice/types';
import { IAdapterData, IError } from '../../../../../../redux/types';
import { ITimestamp } from '../../../../../../utils/types';
import { IRelationship } from '../../../../../containers/EnrolDependents/types';
import { ELOGIN_METHODS } from '../../../types';

export interface IUserSlice {
    userData: {
        // todo remove any later
        data: IUser | any | null;
        loading: boolean;
        error?: IError | null;
    };
    userAttributes: IAdapterData<IUserAttributes>;
}

export interface IUser {
    userId: string;
    firstName: string;
    lastName: string;
    userType: string;
    patientType: string;
    gender: IGender;
    dob: ITimestamp;
    email?: string;
    mobile?: string;
    policyEnabled: boolean;
    legal: boolean;
    joiningDate?: ITimestamp;
    ctc: number;
    coordinatorId: string;
    remainingGiftCount: number;
    relationship: IRelationship;
    visitDurationLimit: ITimestamp;
    chatDurationLimit: ITimestamp;
    dependents?: string[];
    employer: string;
    employeeId: string;
    parentId?: string;
    roles: string[];
    customForms?: Record<string, unknown> | null;
    active: boolean;
    createdAt: ITimestamp;
    updatedAt: ITimestamp;
    backupPhoneNumber: string | null;
    backupEmailAddress: string | null;
    isBackupPhoneVerified: boolean;
    isBackupEmailVerified: boolean;
    backupPhoneVerificationCode: string | null;
    backupEmailVerificationCode: string | null;
    dateOfLeaving: ITimestamp | null;
    createdBy?: string;
    updatedBy?: string;
    maritalStatus?: string;
    previousSI?: string;
    loginMethod?: ELOGIN_METHODS;
}

export type IUserAttributeFieldValue = string | number | Date;
export interface IUserAttributes {
    attributes: IUserAttributeField[];
    conditions?: IUserAttributeCondition[];
    userAttributes?: Record<string, IUserAttributeFieldValue>;
    userConditions?: string[];
    isQuestionnairePending?: boolean;
}

export enum EUserAttributeFieldInputType {
    TEXTFIELD = 'text',
    DROPDOWN = 'dropdown',
    DATE = 'date'
}

export interface IUserAttributeField {
    attributeName: string;
    displayName: string;
    type: 'string' | 'number';
    inputType: EUserAttributeFieldInputType;
    isHrFilled?: boolean;
    allowedValues?: string[];
}

export type IGetUserAttributesResponse = IUserAttributes;

export interface IUserAttributeCondition {
    conditionName: string;
    displayName: string;
    conditionId: string;
    imageUrl?: string;
}
